/* eslint-disable react/no-unescaped-entities */
import * as React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import parse from "autosuggest-highlight/parse";
import { debounce } from "@mui/material/utils";
import PublicIcon from "@mui/icons-material/Public";
import ClearIcon from "@mui/icons-material/Clear";
import LocationOffIcon from '@mui/icons-material/LocationOff';
import RoomOutlinedIcon from "@mui/icons-material/RoomOutlined";
import {
  IconButton,
  InputAdornment,
  Dialog,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { useSearchParams } from "next/navigation";

const GOOGLE_MAPS_API_KEY = process.env.MAPKEY;

function loadScript(src, position, id) {
  if (!position) {
    return;
  }

  const script = document.createElement("script");
  script.setAttribute("async", "");
  script.setAttribute("id", id);
  script.src = src;
  position.appendChild(script);
}


const autocompleteService = { current: null };

export default function PickupLocation({
  type,
  pickup,
  drop,
  setPickup,
  setDrop,
  indx,
  label, newDesign,
  placeholder,
  setLoading,
  loading,
  autocompleteFirst,
  error,
  helperText,
  // pick_up,
  size = 'medium'
}) {
  const searchParam = useSearchParams();
  const pick_up = searchParam.get("pick_up");
  // …inside the component, before the return:

  const inputBorderSx = newDesign
    ? {
      // no borders anywhere
      "& .MuiOutlinedInput-root": {
        "& fieldset": { border: "none" },
        "&:hover fieldset": { border: "none" },
        "&.Mui-focused fieldset": { border: "none" },
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },
      "& .MuiInput-underline:after": { border: "none" },
    }
    : {
      // your current bordered look
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          border: "1px solid rgba(0, 0, 0, 0.5)",
          borderRadius: "8px",
        },
        "&:hover fieldset": { border: "1px solid rgba(0, 0, 0, 0.5)" },
        "&.Mui-focused fieldset": { border: "1px solid rgba(0, 0, 0, 0.5)" },
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: "1px solid rgba(0, 0, 0, 0.5)",
      },
      "& .MuiInput-underline:after": {
        border: "1px solid rgba(0, 0, 0, 0.5)",
      },
    };

  const [value, setValue] = React.useState(null);
  const [inputValue, setInputValue] = React.useState("");
  const [options, setOptions] = React.useState([]);
  const loaded = React.useRef(false);
  // Start
  const [alertShown, setAlertShown] = React.useState(false);

  React.useEffect(() => {
    const knowFirstStatus = sessionStorage.getItem("sessionCurrentFirst")

    const checkGeolocationPermission = async () => {
      try {
        const result = await navigator.permissions.query({
          name: "geolocation",
        });

        if (result.state === "denied") {

          if (!knowFirstStatus) {

            setAlertShown(true);
            sessionStorage.setItem("sessionCurrentFirst", "true");
          }
        } else {
          setAlertShown(false);
        }
      } catch (error) {
        console.error("Error checking geolocation permission:", error);
      }
    };


    checkGeolocationPermission();
  }, []);
  // End

  if (typeof window !== "undefined" && !loaded.current) {
    if (!document.querySelector("#google-maps")) {
      loadScript(
        `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`,
        document.querySelector("head"),
        "google-maps"
      );
    }

    loaded.current = true;
  }

  const fetch = React.useMemo(
    () =>
      debounce((request, callback) => {
        request.componentRestrictions = { country: "ae" };

        autocompleteService.current.getPlacePredictions(request, callback);
      }, 400),
    []
  );

  React.useEffect(() => {
    let active = true;
    if (!pick_up && pickup == "" && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          localStorage.setItem("latitude", latitude);
          localStorage.setItem("longitude", longitude);
          // Ensure that the Google Maps API has been loaded
          if (window.google && window.google.maps) {
            const geocoder = new window.google.maps.Geocoder();
            const latlng = new window.google.maps.LatLng(latitude, longitude);
            geocoder.geocode({ latLng: latlng }, (results, status) => {

              if (status === window.google.maps.GeocoderStatus.OK) {
                if (results[0]) {
                  const locationDescription = results[0].formatted_address;


                  const currentLocation = {
                    description: locationDescription,
                    place_id: "0",
                    structured_formatting: {
                      main_text: locationDescription,
                      main_text_matched_substrings: [
                        {
                          length: 1,
                          offset: 0,
                        },
                      ],
                      secondary_text: "Set your location as pickup address",
                    },
                    terms: [
                      {
                        offset: 0,
                        value: locationDescription,
                      },
                    ],
                    types: ["premise", "geocode"],
                    geometry: {
                      location: {
                        lat: () => latitude,
                        lng: () => longitude,
                      },
                    },
                  };
                  setOptions([currentLocation]);
                  // setValue(currentLocation);
                  setValue((prevValue) =>
                    inputValue === "" ? currentLocation : prevValue
                  );
                  setPickup(locationDescription);
                }
              } else {
                console.error("Geocoder failed due to: " + status);
              }
            });
          } else {
            console.log("Google Maps API not loaded.");
          }
        },
        (error) => {
          setAlertShown(false);
          console.error("Error getting current location:", error);
        }
      );
    }

    // if (!autocompleteService.current && window.google) {
    //   autocompleteService.current =
    //     new window.google.maps.places.AutocompleteService();
    // }
    if (!autocompleteService.current && window.google && window.google.maps && window.google.maps.places) {
      autocompleteService.current = new window.google.maps.places.AutocompleteService();
    }
    if (!autocompleteService.current) {
      return undefined;
    }

    if (inputValue === "") {
      setOptions(value ? [value] : []);
      return undefined;
    }

    fetch({ input: inputValue }, (results) => {
      if (active) {
        let newOptions = [];

        if (value) {
          newOptions = [value];
        }

        if (results) {
          newOptions = [...newOptions, ...results];
        }

        setOptions(newOptions);
      }
    });

    return () => {
      active = false;
    };
  }, [type, value, inputValue, setOptions, setValue, setPickup]);

  const handleClose = () => {
    setAlertShown(false);
  };

  React.useEffect(() => {
    if (type === "pickup") {
      if (value && value.description === "Current Location") {
        setValue("");
      }
      if (value == null) {
        setValue("");
      }
    }
  }, [value, type]);


  return (
    <Box
      className="col-xl-7 col-lg-8"
      sx={{
        width: "auto !important",
        "& label.Mui-focused": {
          color: "black",
        },

        "& .MuiListSubheader-root": {
          // height: "16px",
          backgroundColor: "red",
        },
        "& .MuiInputBase-input": {
          // height: "16px",
        },
        "& .MuiAutocomplete-clearIndicator": {
          display: "none", // Hides the clear (close) button
        },

        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
          border: "1px solid rgba(0, 0, 0, 0.5)",
        },
        "& .MuiInput-underline:after": {
          border: "1px solid rgba(0, 0, 0, 0.5)",
        },
        "& .MuiAutocomplete-listbox": {
          overflow: "hidden",
        },
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            border: "1px solid rgba(0, 0, 0, 0.5)",
            borderRadius: "8px",
          },
          "&:hover fieldset": {
            border: "1px solid rgba(0, 0, 0, 0.5)",
          },
          "&.Mui-focused fieldset": {
            border: "1px solid rgba(0, 0, 0, 0.5)",
          },
        },
        "&::-webkit-scrollbar": {
          width: "2px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#888",
          borderRadius: "6px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "#555",
        },
        ...inputBorderSx
      }}
    >
      <Autocomplete
        id="google-map-demo"
        size={size}
        // sx={{ width: 300 }}
        getOptionLabel={(option) =>
          typeof option === "string" ? option : option.description
        }
        noOptionsText={
          options.length === 0 ? <div style={{
            padding: "16px",
            textAlign: "center",
            color: "#666",
            fontSize: "14px",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px"
          }}>
            <p style={{ marginTop: "5px" }}>
              Please search your {type} location
            </p>
          </div> :
            <div style={{
              padding: "16px",
              textAlign: "center",
              color: "#666",
              fontSize: "14px",
              backgroundColor: "#f8f9fa",
              borderRadius: "8px"
            }}>
              <strong style={{ fontSize: "16px", color: "#333" }}>
                No results found
              </strong>
              <p style={{ marginTop: "5px" }}>
                Please check the airport or city you have entered or select one from the list.
              </p>
            </div>
        }
        filterOptions={(x) => x}
        componentsProps={{
          paper: {
            sx: {
              position: "absolute",
              left: "0 !important",
              right: "0 !important",
              maxWidth: "100%",
              width: "100%"
            },
          },
        }}

        options={options}
        autoComplete
        includeInputInList
        filterSelectedOptions
        value={type === "pickup" ? pickup : drop}
        onChange={(event, newValue) => {
          if (newValue !== null) {
            setOptions(newValue ? [newValue, ...options] : options);
            setValue(newValue);
            if (type === "pickup") {
              setPickup(newValue.description);
            } else {
              setDrop(newValue.description);
            }
          }
        }}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={newDesign ? "" : label}
            size="small"
            placeholder={placeholder}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  {
                    newDesign ? <RoomOutlinedIcon /> : <PublicIcon />
                  }
                </InputAdornment>
              ),
              endAdornment: (
                <>
                  {params.InputProps.endAdornment}
                  {value && (
                    <IconButton
                      onClick={() => {
                        setValue(null);
                        setInputValue("");
                        if (type === "pickup") {
                          setPickup(null);
                        } else {
                          setDrop("");
                        }
                      }}
                      edge="end"
                    >
                      <ClearIcon sx={{
                        height: '14px'
                      }} />
                    </IconButton>
                  )}
                </>
              ),
              style: error ? { borderColor: "red" } : {},
            }}
            error={error}
            helperText={helperText}
            fullWidth
          />
        )}
        renderOption={(props, option) => {
          const matches =
            option.structured_formatting.main_text_matched_substrings || [];

          const parts = parse(
            option.structured_formatting.main_text,
            matches.map((match) => [match.offset, match.offset + match.length])
          );

          return (
            <li {...props}>
              <Grid container alignItems="center">
                <Grid item sx={{ display: "flex", width: 44 }}>
                  <LocationOnIcon sx={{ color: "text.secondary" }} />
                </Grid>
                <Grid
                  item
                  sx={{ width: "calc(100% - 44px)", wordWrap: "break-word" }}
                >
                  {parts.map((part, index) => (
                    <Box
                      key={index}
                      component="span"
                      sx={{ fontWeight: part.highlight ? "bold" : "regular" }}
                    >
                      {part.text}
                    </Box>
                  ))}

                  <Typography variant="body2" color="text.secondary">
                    {option.structured_formatting.secondary_text}
                  </Typography>
                </Grid>
              </Grid>
            </li>
          );
        }}
      />

      <Dialog
        open={alertShown}
        onClose={handleClose}
        PaperProps={{
          style: {
            borderRadius: "16px",
            padding: "20px",
            maxWidth: "450px",
            margin: "auto"
          }
        }}
      >
        <Box display="flex" flexDirection="column" alignItems="center" textAlign="center" p={2}>
          <Box
            sx={{
              backgroundColor: "#ffecec",
              color: "#e53935",
              borderRadius: "50%",
              padding: "12px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mb: 2
            }}
          >
            <LocationOffIcon sx={{ fontSize: 32 }} />
          </Box>

          <Typography variant="h6" fontWeight={600} mb={1}>
            Location Access Disabled
          </Typography>

          <DialogContentText style={{ fontSize: "15px", color: "#555" }}>
            We need access to your location to show better results near you.
            Please enable it from your browser's site settings.
          </DialogContentText>
        </Box>

        <DialogActions
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
            px: 3,
            pb: 2
          }}
        >
          <Button
            onClick={handleClose}
            variant="outlined"
            sx={{
              color: "#6dc8bf",
              borderColor: "#6dc8bf",
              textTransform: "capitalize",
              borderRadius: "8px",
              "&:hover": {
                borderColor: "#6dc8bf",
                backgroundColor: "#6dc8bf",
                color: "#ffffff"
              }
            }}
          >
            Close
          </Button>

        </DialogActions>
      </Dialog>
    </Box>
  );
}
